import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, ListItem, ListItemButton, ListItemText } from "@mui/material";
import React, { useState } from "react";

interface Props {
  title: string | React.ReactElement
  children: React.ReactElement
}

const CollapseItem: React.FC<Props> = ({ title, children }: Props) => {
  const [openCollapse, setOpenCollapse] = useState<boolean>(false);

  return (
    <ListItem>
      <ListItemButton sx={styles.title} onClick={() => setOpenCollapse(!openCollapse)}>
        {openCollapse ? <ExpandLess /> : <ExpandMore />}
        <ListItemText primary={title} />
      </ListItemButton>
      <Collapse sx={styles.contents} in={openCollapse} timeout="auto" unmountOnExit>
        { children }
      </Collapse>
    </ListItem>
  )
}
export default CollapseItem

const styles = {
  title: {
    padding: 0
  },
  contents: {
    marginTop: 1,
    paddingLeft: 3
  }
}
